import { Create, useForm } from '@refinedev/antd';

import { Shipper } from '@/model/Logistic/Shipper/Shipper';

import ShipperForm from './ShipperForm/ShipperForm';

const ShipperCreate = () => {
  const { formProps, saveButtonProps } = useForm<Shipper>();

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ShipperForm formProps={formProps} />
    </Create>
  );
};

export default ShipperCreate;
